var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"thing"},[_c('p',[_vm._v("Hello "+_vm._s(_vm.hello)+" from TestComponent.vue!")])])
}
var staticRenderFns = []

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./scripts/vue/TestComponent.vue